import { c as _c } from "react/compiler-runtime";
import { css } from '@repo/pandacss/css';
import { HStack, VisuallyHidden } from '@repo/pandacss/jsx';
import { starRatingRoot } from '@repo/pandacss/patterns';
import { StarRating, type StarRatingProps } from '@repo/ui/composites/StarRating';
const starsRatingValueClass = css({
  ml: '2',
  fontWeight: '[400]',
  lineHeight: '[1.5]',
  fontSize: {
    base: '[13px]',
    _pcSm: '[1rem]'
  },
  _pcMd: {
    fontWeight: '[700]',
    ml: '[10px]'
  }
});
export const Stars = t0 => {
  const $ = _c(12);
  const {
    starRating
  } = t0;
  const t1 = Number(starRating);
  let t2;
  if ($[0] !== t1) {
    t2 = t1.toFixed(1);
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const formattedRating = t2;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = css({
      flexWrap: "wrap"
    });
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = starRatingRoot.raw({
      size: {
        base: "14px",
        _pcMd: "19px"
      },
      gap: {
        base: "5px",
        _pcMd: "6px"
      }
    });
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== starRating) {
    t5 = <StarRating value={starRating} css={t4} />;
    $[4] = starRating;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <VisuallyHidden>out of 5 stars</VisuallyHidden>;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== formattedRating) {
    t7 = <span className={starsRatingValueClass}>{formattedRating}{t6}</span>;
    $[7] = formattedRating;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== t5 || $[10] !== t7) {
    t8 = <HStack gap="0" className={t3}>{t5}{t7}</HStack>;
    $[9] = t5;
    $[10] = t7;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  return t8;
};